import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=36724e39&scoped=true"
import script from "./Api.vue?vue&type=script&lang=js"
export * from "./Api.vue?vue&type=script&lang=js"
import style0 from "./Api.vue?vue&type=style&index=0&id=36724e39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36724e39",
  null
  
)

export default component.exports